import Modal from "bootstrap/js/src/modal.js";

export const DIALOG_SM = 'sm';
export const DIALOG_MD = 'md';
export const DIALOG_LG = 'lg';
export const DIALOG_XL = 'xl';

const defaultOptions = {
    size: DIALOG_MD,
    title: '',
    content: '',
    show: true,
    keyboard: true,
    backdrop: true,
    showHeader: true,
    showCloseButton: true,
    showFooter: false,
    class: '',
    classcontent: ''
};

let _dialogs = 0;

const updateModalsZIndex = () => {
    let zIndex = 1040;
    jQuery('.modal').each(function () {
        const $modal = jQuery(this);
        $modal.css('z-index', zIndex);
        $modal.prev('.modal-backdrop').css('z-index', zIndex - 5)
        zIndex += 10
    });
};

export class Dialog {

    static SIZE_SM = DIALOG_SM;
    static SIZE_MD = DIALOG_MD;
    static SIZE_LG = DIALOG_LG;
    static SIZE_XL = DIALOG_XL;

    constructor(options = {}) {
        this.options = {
            ...defaultOptions,
            ...options,
        };
        this.cid = 'm' + (++_dialogs);
        this.eventsHandlers = [];
        this.init();
        if (options.show === true) {
            this.show();
        }
    }

    get main() {
        return this.$main?.[0];
    }

    get dialog() {
        return this.$dialog?.[0];
    }

    init() {
        if (this.$main) {
            return;
        }

        this.$main = jQuery('<div>', {class: 'modal fade ' + (this.options.class || ''), id: this.cid, tabindex: -1, role: 'dialog'});
        this.$dialog = jQuery('<div>', {class: 'modal-dialog modal-dialog-centered modal-' + this.options.size, role: 'document'});
        this.$window = jQuery('<div>', {class: 'modal-content ' + (this.options.classcontent || '')});
        this.$content = jQuery('<div>', {class: 'modal-body'}).html(this.options.content);

        this.$closeButton = jQuery('<button>', {
            type: 'button',
            class: 'btn-close',
            'data-bs-dismiss': 'modal',
        });
        if (this.options.showCloseButton !== true) {
            this.$closeButton.hide();
        }

        this.$header = jQuery('<div>', {class: 'modal-header'}).append([
            jQuery('<h4>', {class: 'modal-title fs-sm'}).html(this.options.title),
            this.$closeButton,
        ]);

        if (this.options.showHeader !== true) {
            this.$header.hide();
        }

        this.$footer = jQuery('<div>', {class: 'modal-footer'});
        this.$footer.appendTo(this.$content);
        if (this.options.showFooter !== true) {
            this.$footer.hide();
        }

        this.$main.append([
            this.$dialog.append([
                this.$window.append([
                    this.$header,
                    this.$content,
                    this.$footer,
                ])
            ])
        ]);

        this.modal = new Modal(this.$main[0], {
            show: false,
            keyboard: this.options.keyboard,
            backdrop: this.options.backdrop,
        });

        this.$main.on('show.bs.modal', () => {
            updateModalsZIndex(this.$main);
            this.trigger('show');
        });

        this.$main.on('shown.bs.modal', () => {
            updateModalsZIndex(this.$main);
            this.trigger('shown');
        });

        this.$main.on('hide.bs.modal', () => {
            this.trigger('hide');
        });

        this.$main.on('hidden.bs.modal', () => {
            this.trigger('hidden');
            this.$main.remove();
        });
    }

    showContent(html) {
        this.$content.html(html);
        return this;
    }

    /**
     * Wyświetla widok
     * @param {AbstractView} viewInstance
     */
    showView(viewInstance) {
        if (this.childView) {
            this.childView.destroy();
            this.childView = null;
            this.$content.empty();
        }

        this.childView = viewInstance;
        this.onClose(() => viewInstance.destroy());

        if (!this.$content) {
            this.onOpen(() => {
                this.childView.setElement(this.$content);
                this.childView.render();
            });
        } else {
            this.childView.setElement(this.$content);
            this.childView.render();
        }
        return this;
    }

    getModal() {
        return Modal.getInstance(this.$main[0]);
    }

    show() {
        const modal = this.getModal();
        if (modal) {
            modal.show();
        }
        return this;
    }

    hide() {
        const modal = this.getModal();
        if (modal) {
            modal.hide();
        }
        return this;
    }

    onShow(handler) {
        this.on('show', handler);
    }

    onShown(handler) {
        this.on('shown', handler);
    }

    onHide(handler) {
        this.on('hide', handler);
    }

    onClose(handler) {
        this.on('hide', handler);
    }

    onHidden(handler) {
        this.on('hidden', handler);
    }

    on(event, handler) {
        this.eventsHandlers.push({event, handler});
    }

    triggerOnOpen() {
        return this.trigger('open');
    }

    triggerOnClose() {
        return this.trigger('hide');
    }

    trigger(event) {
        for (let handler of this.eventsHandlers) {
            if (handler.event === event) {
                handler.handler(this);
            }
        }
        return this;
    }

}
